export default __webpack_public_path__ + "static/media/cardBr.bf7ca13b.png";